module.exports = __webpack_public_path__ + "static/media/logo.47888028.svg";


//////////////////
// WEBPACK FOOTER
// ./catalog/static/assets/img/logo/logo.svg
// module id = 781
// module chunks = 9